import React, { useEffect, useRef } from 'react';

/**
 * Ambient glow that trails the pointer, easing toward it at 0.06/frame.
 * Transcribed from v1's [data-glow] element and its rAF loop.
 */
const CursorGlow: React.FC = () => {
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const glow = ref.current;
        if (!glow) return;

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        let tx = window.innerWidth / 2;
        let ty = window.innerHeight / 2;
        let cx = tx;
        let cy = ty;
        let raf = 0;

        const onMove = (e: PointerEvent) => {
            tx = e.clientX;
            ty = e.clientY;
        };

        const loop = () => {
            cx += (tx - cx) * 0.06;
            cy += (ty - cy) * 0.06;
            glow.style.transform = `translate3d(${cx.toFixed(1)}px,${cy.toFixed(1)}px,0)`;
            raf = requestAnimationFrame(loop);
        };

        window.addEventListener('pointermove', onMove, { passive: true });
        raf = requestAnimationFrame(loop);

        return () => {
            window.removeEventListener('pointermove', onMove);
            cancelAnimationFrame(raf);
        };
    }, []);

    return (
        <div
            ref={ref}
            aria-hidden="true"
            className="pointer-events-none fixed left-0 top-0 z-0 -ml-[410px] -mt-[410px] h-[820px] w-[820px] rounded-full bg-hero-glow-ambient will-change-transform"
        />
    );
};

export default CursorGlow;
